<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Hazard Control
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="conte"
                :label="this.localForm.conte"
                :items="hazardControlEffectiveOptions"
                color="wplblue0"
                prepend-icon="shield"
                hint="effectivness"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="conta"
                :label="this.localForm.conta"
                :items="hazardControlAssuranceOptions"
                color="wplblue0"
                prepend-icon="safety_check"
                hint="assurance"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Hazard Control Description
            </div>
          </v-layout>
          <v-layout row wrap class="ml-3 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.contc"
              :disabled="false"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              hint="hazard commments"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs10>
              <v-select
              v-model="barrier"
              :items="hazardBarrierOptions"
              :menu-props="{ maxHeight: '400' }"
              label="Select"
              multiple
              prepend-icon="shield"
              hint="hazard barriers"
              persistent-hint
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs10>
              <v-select
              v-model="control"
              :items="hazardControlOptions"
              :menu-props="{ maxHeight: '400' }"
              label="Select"
              multiple
              prepend-icon="health_and_safety"
              hint="hazard controls"
              persistent-hint
              ></v-select>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import hazardOptions from "@/data/options/mixins/hazardOptions.js";
import disciplineOptions from "@/data/options/mixins/disciplineOptions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      ctr: 0,
      localForm: {
        conta: "",
        control: "",
        barrier: "",
        conte: "",
        contc: ""
      },
      orgForm: {
        conta: "",
        control: "",
        barrier: "",
        conte: "",
        contc: ""
      },
      conte: "",
      conta: "",
      control: "",
      barrier: ""
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.conte = this.getDetail.char.conte;
    this.localForm.conta = this.getDetail.char.conta;
    this.localForm.contc = this.getDetail.char.contc;

    this.orgForm.conte = this.getDetail.char.conte;
    this.orgForm.conta = this.getDetail.char.conta;
    this.orgForm.contc = this.getDetail.char.contc;

    this.barrier = this.getDetailRelps.s3;
    this.control = this.getDetailRelps.s4;
  },
  watch: {
    conta() {
      this.localForm.conta = this.conta;
      this.updateFormChar();
    },
    control() {
      this.localForm.control = this.control;
      this.updateFormRelps();
    },
    barrier() {
      this.localForm.barrier = this.barrier;
      this.updateFormRelps();
    },
    conte() {
      this.localForm.conte = this.conte;
      this.updateFormChar();
    }
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    hazardOptions,
    disciplineOptions
  ],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailChar",
      "getDetailRelps",
      "getCurrentPage"
    ])
  },
  mounted() {
    this.$store.dispatch("changeDataSavePendingIndication", false);
  },
  methods: {
    updateFormRelps() {
      let relps = this.getDetailRelps;
      relps.s3 = this.barrier;
      relps.s4 = this.control;
      this.$store.dispatch("changeDetailRelps", relps);
      this.saveDocumentRevMod(4.17, 1); // business mod.
      // when loaded first time ctr is = 1 as s3 / s4 load
      if (this.ctr > 1) {
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      // This conter ensure that the Hazard Contrl does not fire
      //  in the first page show
      this.ctr = this.ctr + 1;
    },
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.conte !== this.orgForm.conte &&
        this.localForm.conte !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.conte = this.localForm.conte;
        // basic
        char.conte = this.localForm.conte;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.conta !== this.orgForm.conta &&
        this.localForm.conta !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.conta = this.localForm.conta;
        // basic
        char.conta = this.localForm.conta;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.contc !== this.orgForm.contc &&
        this.localForm.contc !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.contc = this.localForm.contc;
        // basic
        char.contc = this.localForm.contc;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
